import { IDelegateController, IDelegateConstant } from 'ui-ng-delegate';

class PhxUniversityCustomBrandingDelegate {
  constructor (DelegateController: IDelegateController, phxUniversityCustomBrandingDelegateConstant: IDelegateConstant) {
    DelegateController(this, phxUniversityCustomBrandingDelegateConstant);
  }
}

angular.module('ui-ng-university-branding')
  .service('phxUniversityCustomBrandingDelegate', PhxUniversityCustomBrandingDelegate)
  .constant('phxUniversityCustomBrandingDelegateConstant', {
    uniqueComponent: 'university-custom-brand',
    vocabulary: {
      setUniversity: (scope: any, element: any, attrs: any, event: any, universityName: string): void => {

        if (!universityName) {
          return;
        }

        element.attr('href', `university/${universityName}/brand.css`);
        attrs.universityName = universityName;
      }
    }
  })
  .directive('phxUniversityCustomBranding', function (DelegateResponder: any, phxUniversityCustomBrandingDelegateConstant: any) {
    return {
      restrict: 'A',
      replace: false,
      scope: false,
      compile: (_element: ng.IAugmentedJQuery, _attrs: ng.IAttributes): any => {
        _element.attr('rel', 'stylesheet');
        _element.attr('type', 'text/css');
        return DelegateResponder(phxUniversityCustomBrandingDelegateConstant, function (scope: any, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void {
          attrs.$observe('universityCustomBranding', (universityName: string): void => {
            scope.setUniversity(universityName);
          });
          attrs.$observe('universityName', (universityName: string): void => {
            scope.setUniversity(universityName);
          });
        });
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-university-branding/dist/lib/university_custom_branding.ts